import React from 'react';

import { styled } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';

import DialogContent from '@mui/material/DialogContent';

import {
  Button,
  FormControl,
  Select,
  IconButton,
  FormControlProps,
} from '@mui/material';
import { DatePicker } from '@mui/lab';

export const DialogContentStyled = styled(DialogContent)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

export const DialogActionsStyled = styled(DialogContent)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

const OutlinedFormControl = ({ ...props }: FormControlProps) => (
  <FormControl variant="outlined" {...props}>
    {props.children}
  </FormControl>
);

export const FormControlStyled = styled(OutlinedFormControl)(
  ({ theme }: { theme: Theme }) => ({
    width: '250px',
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: '32px',
    },
  }),
);

export const ButtonStyled = styled(Button)(({ theme }: { theme: Theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(2),
}));

export const ButtonClear = styled(Button)`
  margin-left: 8px;
  margin-bottom: 4px;
`;

export const Error = styled('div')(({ theme }: { theme: Theme }) => ({
  color: theme.palette.error.main,
  marginTop: `-theme.spacing(2)`,
}));

export const SelectStyled = styled(Select)`
  variant="outlined"
  margin="dense"
`;
export const IconButtonStyled = styled(IconButton)`
  padding: 0;
  margin: 0;
`;

export const KeyboardDatePickerStyled = styled(DatePicker)(
  ({ theme }: { theme: Theme }) => ({
    marginBottom: theme.spacing(2),
  }),
);
